export default __webpack_public_path__ + "static/WebDev-01 1-2c7c33e3767f94ea9835ca6c8cb9661f.png";